export default {
  message: '',
  alertFlag: false
}
